var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 32C3.594 32 0 35.594 0 40S3.594 48 8 48C241.781 48 432 238.219 432 472C432 476.406 435.594 480 440 480S448 476.406 448 472C448 229.375 250.625 32 8 32ZM8 176C3.594 176 0 179.594 0 184S3.594 192 8 192C162.406 192 288 317.594 288 472C288 476.406 291.594 480 296 480S304 476.406 304 472C304 308.781 171.219 176 8 176ZM64 352C28.654 352 0 380.654 0 416S28.654 480 64 480C99.348 480 128 451.346 128 416S99.348 352 64 352ZM64 464C37.533 464 16 442.467 16 416S37.533 368 64 368S112 389.533 112 416S90.467 464 64 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.1ec1dacc03f36cf8546d8817ee740be7.svg";
export { ForwardRef as ReactComponent };